export enum SidebarState {
    CLOSED = 'closed',
    OPEN = 'open',
    HOVER = 'hover',
    HIDDEN = 'hidden',
}
